import * as yup from 'yup';
export const validationSchema = yup.object().shape({
  count: yup
    .number()
    .min(1, 'A minimum of 1 is required')
    .max(100, 'A maximum of 100 orders is allowed')
    .required('Number of orders is required'),
  nationality: yup.object().nullable().optional(),
});
